import React from "react";
import { Redirect } from "react-router-dom";

export default function LaunchToUserInfo() {
  return <Redirect to="/db/setting/account/user_info" />;
}
